export default __webpack_public_path__ + "static/parigi-plus-2-f4e4cda6691d0b03b5887e7e8b389a79.jpg";